import type en from '../en/nav'
import type { Translation } from '../types'

/** The menu and the frame around every page */
const nav: Translation<typeof en> = {
  "nav.overview": "Übersicht",
  "nav.admins": "Administratoren",
  "nav.models": "Modelle",
  "nav.companies": "Unternehmen",
  "nav.settings": "Einstellungen",
  "nav.vpn": "VPN",
  "nav.edge": "Edge-Proxy",
  "nav.licensePlans": "Lizenzpläne",
  "nav.licenseOverview": "Lizenzübersicht",
  "nav.myProfile": "Mein Profil",
  "nav.dashboard": "Dashboard",
  "nav.monitoring": "Überwachung",
  "nav.alerts": "Warnungen",
  "nav.sites": "Standorte",
  "nav.templates": "Vorlagen",
  "nav.users": "Benutzer",
  "nav.roles": "Rollen",
  "nav.branding": "Branding",
  "nav.messages": "Nachrichten",
  "nav.apiKeys": "API-Schlüssel",
  "nav.webhooks": "Webhooks",
  "nav.notifications": "Benachrichtigungen",
  "nav.roleGlobalAdmin": "Globaler Administrator",
  "nav.roleAdmin": "Administrator",
  "nav.roleUser": "Benutzer",
  "nav.switchCompany": "Unternehmen wechseln",
  "nav.logout": "Abmelden",
  "nav.expand": "Ausklappen",
  "nav.collapse": "Einklappen",
  "nav.expandMenu": "Menü ausklappen",
  "nav.collapseMenu": "Menü einklappen",
  "nav.openMenu": "Menü öffnen",
  "nav.closeMenu": "Menü schließen",
  "nav.licenseExpired": "Ihre Lizenz ist abgelaufen. Das Dashboard ist schreibgeschützt, bis sie verlängert wird.",
  "nav.passwordLeaked": "Ihr Passwort taucht in einem bekannten Datenleck auf; andere könnten es ausprobieren.",
  "nav.passwordLeakedChange": "Ändern Sie es jetzt unter",
  "nav.rental": "Vermietung",
  "nav.inbox": "Posteingang",
  "nav.inboxUnread": "Posteingang, {count} ungelesen",
  "nav.inboxReadAll": "Alle als gelesen markieren",
  "nav.inboxEmpty": "Noch nichts hier",
  "nav.pushRelay": "Push-Weiterleitung",
}

export default nav
